"use client";
/*
 * Documentation:
 * Button — https://app.subframe.com/4f62853ee923/library?component=Button_3b777358-b86b-40af-9327-891efc6826fe
 * PRINT_DC_Card_Hash — https://app.subframe.com/4f62853ee923/library?component=PRINT_DC_Card_Hash_336fb59f-1c04-426a-960c-d3a83065e279
 */

import React from "react";
import * as SubframeUtils from "../utils";
import { Button } from "./Button";

interface JumpLinkProps extends React.ComponentProps<typeof Button> {
  children?: React.ReactNode;
  className?: string;
}

const JumpLink = React.forwardRef<
  React.ElementRef<typeof Button>,
  JumpLinkProps
>(function JumpLink(
  { children, className, ...otherProps }: JumpLinkProps,
  ref
) {
  return (
    <Button
      className={className}
      variant="brand-secondary"
      ref={ref}
      {...otherProps}
    >
      {children}
    </Button>
  );
});

interface Print_Dc_Card_HashRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  headline?: React.ReactNode;
  imageSlot?: React.ReactNode;
  text?: React.ReactNode;
  buttonSlot?: React.ReactNode;
  className?: string;
}

const Print_Dc_Card_HashRoot = React.forwardRef<
  HTMLDivElement,
  Print_Dc_Card_HashRootProps
>(function Print_Dc_Card_HashRoot(
  {
    headline,
    imageSlot,
    text,
    buttonSlot,
    className,
    ...otherProps
  }: Print_Dc_Card_HashRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex items-center rounded-md bg-neutral-50 px-4 py-4",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex flex-col items-center gap-6">
        {headline ? (
          <span className="w-full text-heading-3 font-heading-3 text-default-font">
            {headline}
          </span>
        ) : null}
        {imageSlot ? (
          <div className="flex w-full items-center gap-2 overflow-hidden rounded-md">
            {imageSlot}
          </div>
        ) : null}
        <div className="flex w-full flex-col items-start gap-4">
          {text ? (
            <span className="w-full text-body font-body text-default-font">
              {text}
            </span>
          ) : null}
          {buttonSlot ? (
            <div className="flex flex-col items-start gap-6">{buttonSlot}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
});

export const Print_Dc_Card_Hash = Object.assign(Print_Dc_Card_HashRoot, {
  JumpLink,
});
